export default [
    {
        path: "/lottery/index/:lid",
        name: "loindex",
        props:true,
        component: () => import(/* webpackChunkName: "activity" */"../views/Lottery/Index.vue"),
        meta: {
            title: "加入抽奖",
            showloading: false,
            requiresAuth: false
        }
    },
    {
        path: "/lottery/welcome",
        name: "lowe",
        component: () => import(/* webpackChunkName: "Orient" */"../views/Lottery/welcome.vue"),
        meta: {
            title: "欢迎",
            showloading: false,
            requiresAuth: false
        }
    }
];
